import { Container, Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import './AboutMe.css';

import FormationsCard from './FormationsCard';
import { useState } from 'react';

import medacLogo from '../assets/img/logos/medac-logo.png';
import davinciLogo from '../assets/img/logos/davinci-logo.avif';
import perfil from '../assets/img/perfil.avif';
import develop from '../assets/img/logos/logo_desarrollo2.avif'
import cibersecurity from '../assets/img/logos/ciberseguridad_logo.avif'
import BClogo from '../assets/img/logos/bussiness_central.avif';

import {
    SiReact,
    SiNodedotjs,
    SiGit,
    SiPostgresql,
    SiMongodb,
    SiDocker
} from '@icons-pack/react-simple-icons';
import { FaAws, FaFileDownload } from 'react-icons/fa';


export const AboutMe = () => {

    const [showFormacion, setShowFormations] = useState(false);

    const techStack = [
        { icon: <SiReact color='default' size={28} />, name: 'React' },
        { icon: <SiNodedotjs color='default' size={28} />, name: 'Node.js' },
        { icon: <img src={BClogo} alt="Business Central" style={{ width: 40, height: "auto" }} />, name: 'Business Central' },
        { icon: <SiDocker size={28} />, name: 'Docker' },
        { icon: <SiMongodb color='default' size={28} />, name: 'MongoDB' },
        { icon: <SiPostgresql color='default' size={28} />, name: 'PostgreSQL' },
        { icon: <FaAws color='white' size={28} />, name: 'AWS' },
        { icon: <SiGit color='default' size={28} />, name: 'Git' },
    ];

    const stats = [
        {
            number: 'DAW',
            label: 'CFGS Oficial',
            icon: develop,
            logo: medacLogo
        },
        {
            number: 'Ciberseguridad',
            label: 'Especialización',
            icon: cibersecurity,
            logo: davinciLogo
        }
    ];

    const handleViewCV = () => {
        window.open('/CV_JuanAngelPenarrubia.pdf', '_blank');
    };

    const handleDownloadCV = () => {
        const link = document.createElement('a');
        link.href = '/CV_JuanAngelPenarrubia.pdf';
        link.download = 'CV_JuanAngelPenarrubia.pdf';
        link.click();
    };

    return (
        <section className="about-me" id="aboutMe">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} className="d-md-none mb-4 text-center">
                        <div className="section-header">
                            <h2>Sobre mí</h2>
                            <p className="subtitle">Desarrollador Full-Stack & Estudiante de Ciberseguridad</p>
                        </div>
                    </Col>

                    <Col xs={12} md={5} lg={4} >
                        <div className="about-left">
                            <div className="profile-image-wrapper">
                                <img
                                    src={perfil}
                                    alt="Juan Ángel Peñarrubia"
                                    className="profile-image"
                                />
                                <div className="image-border"></div>
                            </div>

                            <div className="tech-stack">
                                <h4>Tech Stack</h4>
                                <div className="tech-grid">
                                    {techStack.map((tech, index) => (
                                        <div key={index} className="tech-icon" title={tech.name}>
                                            {tech.icon}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <ButtonGroup size="lg" className="mb-2">
                                <Button
                                    variant="outline-primary"
                                    className="cv-button-left"
                                    onClick={handleViewCV}
                                >
                                    <span>Ver Curriculum</span>
                                </Button>

                                <Button
                                    variant="outline-primary"
                                    className="cv-button"
                                    onClick={handleDownloadCV}
                                    title="Descargar Currículum"
                                >
                                    <span><FaFileDownload style={{ color: 'white',  margin: '-40% 0 0 -30%' }} /></span>
                                </Button>
                            </ButtonGroup>
                        </div>
                    </Col>

                    <Col xs={12} md={7} lg={8} className="text-center">
                        <div className="about-right">
                            <div className="section-header d-none d-md-block">
                                <h2>Sobre mí</h2>
                                <p className="subtitle">Desarrollador Full-Stack & Estudiante de Ciberseguridad</p>
                            </div>

                            {/* Biografía */}
                            <div className="about-content">
                                <p className="intro">
                                    Desarrollador full-stack apasionado por crear <span className="highlight">soluciones seguras y escalables</span>.
                                    Con Formación en diversos Frameworks y con sólida base en ciberseguridad.
                                </p>

                                <p>
                                    Mi preparación abarca desde el desarrollo de interfaces modernas con React o Angular hasta la implementación
                                    de APIs robustas con Node.js o Flask.
                                </p>

                                <p>
                                    Siempre enfocado en <span className="highlight">código limpio</span>, arquitecturas escalables y
                                    seguridad desde el diseño. Me apasiona aprender nuevas tecnologías y enfrentar desafíos técnicos complejos.
                                </p>
                            </div>
                            <h2 className='formacion'>Formación</h2>
                            <Row className="stats-row">
                                {stats.map((stat, index) => (
                                    <Col xs={6} sm={5} key={index}>
                                        <div className="stat-card">
                                            <div className="stat-logo-overlay">
                                                <img
                                                    src={stat.logo}
                                                    alt={stat.label}
                                                    className="institute-logo"
                                                />
                                            </div>
                                            <span className="stat-icon"><img src={stat.icon} alt="" /></span>
                                            <h3>{stat.number}</h3>
                                            <p>{stat.label}</p>
                                        </div>
                                    </Col>
                                ))}
                                <Button
                                    variant="outline-primary"
                                    className="complementary-btn"
                                    onClick={() => setShowFormations(true)}
                                >
                                    📜 Ver cursos complementarios
                                </Button>
                                {showFormacion && (
                                    <FormationsCard onClose={() => setShowFormations(false)} />
                                )}
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>

            <div className="background-elements">
                <span className="floating-bracket bracket-1">&lt;/&gt;</span>
                <span className="floating-bracket bracket-2">&#123; &#125;</span>
            </div>
        </section>
    );
};